// extracted by mini-css-extract-plugin
module.exports = {"MasterArtikalForm":"MasterArtikalForm_MasterArtikalForm__2n2xB","ComboBoxOption":"MasterArtikalForm_ComboBoxOption__1gGsQ","Selected":"MasterArtikalForm_Selected__1q40E"};